/*
 * Shared dealer data + helpers: window.KabutoDealers.
 * Used by assets/dealer-locator.js (dealers page) and assets/dealer-nearby.js
 * ("Try it on near you" on helmet product pages). Free services only:
 * ZIP codes resolve offline from assets/dealer-zip-N.json (US Census ZCTA
 * centroids); other places use OpenStreetMap Nominatim.
 */
(function () {
  if (window.KabutoDealers) return;

  var STATES = {
    alabama: 'al', alaska: 'ak', arizona: 'az', arkansas: 'ar', california: 'ca', colorado: 'co', connecticut: 'ct',
    delaware: 'de', florida: 'fl', georgia: 'ga', hawaii: 'hi', idaho: 'id', illinois: 'il', indiana: 'in', iowa: 'ia',
    kansas: 'ks', kentucky: 'ky', louisiana: 'la', maine: 'me', maryland: 'md', massachusetts: 'ma', michigan: 'mi',
    minnesota: 'mn', mississippi: 'ms', missouri: 'mo', montana: 'mt', nebraska: 'ne', nevada: 'nv',
    'new hampshire': 'nh', 'new jersey': 'nj', 'new mexico': 'nm', 'new york': 'ny', 'north carolina': 'nc',
    'north dakota': 'nd', ohio: 'oh', oklahoma: 'ok', oregon: 'or', pennsylvania: 'pa', 'rhode island': 'ri',
    'south carolina': 'sc', 'south dakota': 'sd', tennessee: 'tn', texas: 'tx', utah: 'ut', vermont: 'vt',
    virginia: 'va', washington: 'wa', 'west virginia': 'wv', wisconsin: 'wi', wyoming: 'wy', 'district of columbia': 'dc'
  };
  var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  var SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  var MODELS = { f17: 'F-17 GP Mips®', geosys: 'GEOSYS GT Mips®', aeroblade: 'Aeroblade-F Mips®' };
  var SERVICES = { fitting: 'Helmet fitting', demo: 'Try-on helmets', parts: 'Shields & parts' };
  var ORIGIN_KEY = 'kabuto-dealer-origin';
  var ORIGIN_TTL = 30 * 24 * 3600 * 1000;
  var CACHE_TTL = 30 * 60 * 1000;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, ' and ');
  }
  function words(s) {
    return norm(s).split(/[^a-z0-9]+/).filter(Boolean);
  }
  function num(v) {
    var n = parseFloat(v);
    return isFinite(n) ? n : null;
  }
  function slugify(s) {
    return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function distanceMi(a, b) {
    var R = 3958.8;
    var dLat = ((b.lat - a.lat) * Math.PI) / 180;
    var dLng = ((b.lng - a.lng) * Math.PI) / 180;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }
  function formatDistance(mi) {
    if (mi == null || !isFinite(mi)) return '';
    return (mi < 10 ? mi.toFixed(1) : Math.round(mi).toLocaleString('en-US')) + ' mi';
  }

  /* ---------- storage (never required) ---------- */
  function readStore(store, key) {
    try { return JSON.parse(store.getItem(key)); } catch (e) { return null; }
  }
  function writeStore(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) { /* private mode etc. */ }
  }
  var ss = (function () { try { return window.sessionStorage; } catch (e) { return null; } })();
  var ls = (function () { try { return window.localStorage; } catch (e) { return null; } })();

  /* ---------- locations ---------- */
  function toLocation(d, i, cfg) {
    var isDealer = d.kind === 'dealer';
    var urlSlug = d.url ? String(d.url).split('/stores/')[1] : '';
    var loc = {
      id: d.id || urlSlug || 'r' + i,
      kind: isDealer ? 'dealer' : 'retail',
      brand: isDealer ? 'dealer' : d.brand,
      name: d.name || '',
      address: d.address || '',
      address2: d.address2 || '',
      city: d.city || '',
      state: d.state || '',
      zip: d.zip || '',
      country: d.country || '',
      phone: d.phone || '',
      tel: d.tel || (d.phone ? 'tel:' + String(d.phone).replace(/[^\d+]/g, '') : ''),
      website: d.website || '',
      websiteText: d.websiteText || '',
      url: d.url || '',
      customDirections: d.directions || '',
      logo: d.logo || '',
      badge: d.badge || '',
      hours: Array.isArray(d.hours) ? d.hours : null,
      hoursText: d.hoursText || '',
      tz: d.tz || '',
      closed: !!d.closed,
      callAhead: isDealer ? d.callAhead !== false : true,
      models: d.models || [],
      services: d.services || [],
      lat: num(d.lat),
      lng: num(d.lng),
      order: i
    };
    var st = STATES[norm(loc.state)] || '';
    loc.stateCode = st;
    loc.tokens = words([loc.name, isDealer ? 'kabuto authorized dealer' : loc.brand, loc.address, loc.address2, loc.city, loc.state, st, loc.zip, loc.country].join(' '));
    loc.label = isDealer ? (cfg && cfg.authorizedLabel) || 'Authorized Kabuto dealer' : loc.brand;
    return loc;
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status + ' ' + url);
      return r.json();
    });
  }

  function cached(key, maker) {
    var hit = ss && readStore(ss, key);
    if (hit && hit.t && Date.now() - hit.t < CACHE_TTL) return Promise.resolve(hit.v);
    return maker().then(function (v) {
      if (ss) writeStore(ss, key, { t: Date.now(), v: v });
      return v;
    });
  }

  // cfg = the dealer locator's [data-dealer-config] JSON.
  function loadFromConfig(cfg) {
    var dealers = (cfg.dealers || []).filter(function (d) { return d.name; });
    var retail = cfg.retailUrl
      ? cached('kabuto-dealers-retail:' + cfg.retailUrl, function () { return fetchJson(cfg.retailUrl); })
          .then(function (data) { return (data && data.stores) || []; })
          .catch(function (e) { console.error('Retail store list failed to load', e); return []; })
      : Promise.resolve([]);
    return retail.then(function (stores) {
      var all = dealers.map(function (d, i) { return toLocation(d, i, cfg); });
      stores.forEach(function (d, i) { all.push(toLocation(d, dealers.length + i, cfg)); });
      return all;
    });
  }

  // Reads the config from the dealers page itself (used on product pages).
  function loadConfigFromPage(pageUrl) {
    return cached('kabuto-dealers-config:' + pageUrl, function () {
      return fetch(pageUrl, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-dealer-config]');
          if (!el) throw new Error('No dealer locator on ' + pageUrl);
          return JSON.parse(el.textContent);
        });
    });
  }

  /* ---------- place lookup ---------- */
  var memo = {};
  function lookup(query, cfg) {
    var q = String(query || '').trim();
    var key = norm(q);
    if (!q) return Promise.resolve(null);
    if (memo[key]) return Promise.resolve(memo[key]);
    var zip = q.match(/^(\d{5})(?:-\d{4})?$/);
    var geoCache = ss && readStore(ss, 'kabuto-dealer-geocode') || {};
    var p;
    if (zip) {
      var urls = (cfg && cfg.zipUrls) || [];
      var shardUrl = urls[+zip[1].charAt(0)];
      p = shardUrl
        ? cached('kabuto-dealer-zip:' + zip[1].charAt(0), function () { return fetchJson(shardUrl); })
            .then(function (shard) {
              var hit = shard && shard[zip[1]];
              return hit ? { lat: hit[0], lng: hit[1], label: zip[1], kind: 'zip' } : null;
            })
            .catch(function () { return null; })
        : Promise.resolve(null);
    } else if (geoCache[key]) {
      p = Promise.resolve(geoCache[key]);
    } else if (cfg && cfg.addressSearch === false) {
      p = Promise.resolve(null);
    } else {
      var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&addressdetails=0&countrycodes=us,co&q=' + encodeURIComponent(q);
      p = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : []; })
        .then(function (res) {
          if (!res || !res.length) return null;
          var hit = { lat: +(+res[0].lat).toFixed(3), lng: +(+res[0].lon).toFixed(3), label: q, kind: 'place' };
          geoCache[key] = hit;
          if (ss) writeStore(ss, 'kabuto-dealer-geocode', geoCache);
          return hit;
        })
        .catch(function () { return null; });
    }
    return p.then(function (hit) { if (hit) memo[key] = hit; return hit; });
  }

  /* ---------- saved origin (per browser) ---------- */
  var origin = {
    get: function () {
      var o = ls && readStore(ls, ORIGIN_KEY);
      if (!o || !isFinite(o.lat) || !isFinite(o.lng) || !o.t || Date.now() - o.t > ORIGIN_TTL) return null;
      return o;
    },
    set: function (o) {
      if (!ls || !o) return;
      // Coordinates from "Use my location" are rounded to ~1 km.
      writeStore(ls, ORIGIN_KEY, { lat: +(+o.lat).toFixed(2), lng: +(+o.lng).toFixed(2), label: o.label, kind: o.kind, t: Date.now() });
    },
    clear: function () { try { ls && ls.removeItem(ORIGIN_KEY); } catch (e) { /* ignore */ } }
  };

  /* ---------- hours ---------- */
  function fmtTime(hhmm) {
    var h = +hhmm.slice(0, 2);
    var m = hhmm.slice(2, 4);
    var ap = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12 || 12;
    return h12 + (m === '00' ? '' : ':' + m) + ' ' + ap;
  }
  function range(entry) {
    if (!entry) return null;
    var p = String(entry).split('-');
    return { open: p[0], close: p[1], openMin: +p[0].slice(0, 2) * 60 + +p[0].slice(2), closeMin: +p[1].slice(0, 2) * 60 + +p[1].slice(2) };
  }
  function localNow(tz, now) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now || new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return { day: SHORT.indexOf(o.weekday), min: (+o.hour % 24) * 60 + +o.minute };
    } catch (e) { return null; }
  }
  // { open: bool, closedAll: bool, label } or null when there are no hours.
  function openState(loc, now) {
    if (loc.closed) return { open: false, closedAll: true, label: 'Temporarily closed' };
    if (!loc.hours || !loc.tz) return null;
    var t = localNow(loc.tz, now);
    if (!t || t.day < 0) return null;
    var today = range(loc.hours[t.day]);
    if (today && t.min >= today.openMin && t.min < today.closeMin) {
      return { open: true, label: 'Open now · until ' + fmtTime(today.close) };
    }
    if (today && t.min < today.openMin) return { open: false, label: 'Closed · opens ' + fmtTime(today.open) };
    for (var i = 1; i <= 7; i++) {
      var d = (t.day + i) % 7;
      var r = range(loc.hours[d]);
      if (r) return { open: false, label: 'Closed · opens ' + (i === 1 ? 'tomorrow' : SHORT[d]) + ' ' + fmtTime(r.open) };
    }
    return { open: false, label: 'Closed' };
  }
  function hoursRows(loc, now) {
    if (!loc.hours) return [];
    var t = loc.tz ? localNow(loc.tz, now) : null;
    return DAYS.map(function (day, i) {
      var r = range(loc.hours[i]);
      return { day: day, text: r ? fmtTime(r.open) + ' – ' + fmtTime(r.close) : 'Closed', today: !!t && t.day === i };
    });
  }

  /* ---------- directions ---------- */
  function isApple() {
    var ua = navigator.userAgent || '';
    if (/iPad|iPhone|iPod/.test(ua)) return true;
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    return /Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome|Chromium|CriOS|Edg|Firefox|OPR/.test(ua);
  }
  function addressLine(loc) {
    return [loc.address, loc.address2, loc.city, (loc.state + ' ' + loc.zip).trim(), loc.country].filter(Boolean).join(', ');
  }
  function directionsUrl(loc) {
    if (loc.customDirections) return loc.customDirections;
    var addr = addressLine(loc);
    if (isApple()) {
      return 'https://maps.apple.com/?daddr=' + encodeURIComponent(addr) + '&q=' + encodeURIComponent(loc.name);
    }
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(loc.name + ', ' + addr);
  }

  /* ---------- analytics (Shopify customer events) ---------- */
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) { /* never break the page for analytics */ }
  }

  /* ---------- card pieces shared by the dealer page and the product-page panel ---------- */
  var ICON = {
    directions: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 2 2 12l10 10 10-10z"/><path d="M9 13v-2h5V8.5L17 12l-3 3.5V13"/></svg>',
    phone: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/></svg>',
    link: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14 4h6v6M20 4 10 14M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>',
    pin: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 22s7-6.1 7-12a7 7 0 0 0-14 0c0 5.9 7 12 7 12z"/><circle cx="12" cy="10" r="2.5"/></svg>',
    share: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg>',
    clock: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>'
  };

  function addressHtml(loc, cfg) {
    var lines = [loc.address, loc.address2].filter(Boolean).map(esc);
    var region = (loc.state + ' ' + loc.zip).trim();
    var locality = [loc.city, region].filter(Boolean).join(', ');
    if (locality) lines.push(esc(locality));
    if (loc.kind === 'dealer' && cfg && cfg.showCountry && loc.country) lines.push(esc(loc.country));
    return lines.join('<br>');
  }

  // prefix = the stylesheet's class prefix (dealer-locator__ / dealer-nearby__)
  function openHtml(loc, prefix, tag) {
    if (!loc.open) return '';
    tag = tag || 'p';
    var cls = prefix + 'open' + (loc.open.closedAll ? ' ' + prefix + 'open--closed-all' : loc.open.open ? ' is-open' : '');
    return '<' + tag + ' class="' + cls + '">' + ICON.clock + esc(loc.open.label) + '</' + tag + '>';
  }

  window.KabutoDealers = {
    MODELS: MODELS,
    SERVICES: SERVICES,
    esc: esc,
    norm: norm,
    words: words,
    slugify: slugify,
    distanceMi: distanceMi,
    formatDistance: formatDistance,
    loadFromConfig: loadFromConfig,
    loadConfigFromPage: loadConfigFromPage,
    lookup: lookup,
    origin: origin,
    openState: openState,
    hoursRows: hoursRows,
    fmtTime: fmtTime,
    directionsUrl: directionsUrl,
    addressLine: addressLine,
    ICON: ICON,
    addressHtml: addressHtml,
    openHtml: openHtml,
    track: track
  };
})();
